export const BENGUIDE_MODE_EDIT = 'BENGUIDE_MODE_EDIT';
export const BENGUIDE_MODE_VIEW = 'BENGUIDE_MODE_VIEW';

export const WAIVED = { value: 'Waived', type: 'WAIVED' };
